<template>
  <!-- error.length>0 ?"error-border" :"" -->
  <div :class="['input-range', isClickOne && errHint?'isEmpty':'']">
    <el-input-number v-model="beforeValue" @blur="blurInput" size="small" controls-position="right" :precision="0" placeholder="最小值" :min='0' :max="max" @change="beforeChange" />
    <span class="range-divided">~</span>
    <el-input-number v-model="afterValue" @blur="blurInput" size="small" controls-position="right" :precision="0" placeholder="最大值" :min='1' :max="max" @change="afterChange" />
    <span class="range-suffix-con" v-if="unit">{{unit}}</span>

    <div class="err-empty">{{errHint}}</div>
  </div>
</template>

<script>
export default {
  props: ['value', 'unit','max'],
  name: 'inputRange',
  inject:['$_search'],
  data () {
    return {
      isClickOne: false,
      errHint: '', // 错误提示
      beforeValue: 0,
      afterValue: 1,
      passValidate: true
    }
  },
  mounted () {
    this.errHint = ''
    if (this.value && this.value.length) {
      this.beforeValue = this.value[0]
      this.afterValue = this.value[1]
    } else {
      this.$emit('change', [0, 1])
    }

    // 搜索事件監聽
    this.$_search.$on('search',(e)=>{
      this.isClickOne = true
      console.log('------點擊搜索啦啦啦啦-----')
    })
  },
  methods: {
    // 失去焦点
    blurInput() {
      this.isClickOne = true
    },
    beforeBlur () {
      this.$emit('validateNode')
    },
    afterBlur () {
      this.$emit('validateNode')
    },
    changeFunc (value, type) {
      let arr = []
      if (typeof this.beforeValue === 'undefined' || typeof this.afterValue === 'undefined') {
        arr = []
        this.errHint = '请输入最小最大值'
        // this.$emit('change', [])
      } else {
        arr = [this.beforeValue, this.afterValue]
        if(this.beforeValue > this.afterValue){
          this.errHint = '最小值不能大于最大值'
        } else {
          this.errHint = ''
        }
        // if (this.beforeValue <= this.afterValue) {
        //   arr = [this.beforeValue, this.afterValue]
        // } else {
        //   arr = [this.afterValue, this.beforeValue]
        // }
      }
      this.$emit('change', arr)
    },
    beforeChange (value) {
      this.changeFunc(value, 'before')
    },
    afterChange (value) {
      this.changeFunc(value, 'after')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-input-number--small {
  // width: 160px;
  width: 130px;
}
.input-range {
  display: flex;
  align-items: center;
  justify-items: stretch;
  width: 400px;
  font-size: 12px;
  color: #595959;
}
.range-input {
  height: 100%;
  // width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
  padding-left: 4px;
  .range-suffix-con {
    flex-shrink: 0;
    padding-right: 4px;
  }
  &:focus-within {
    outline: 1px solid #ff9052;
    box-shadow: 0px 0px 8px 0px rgba(255, 144, 82, 0.4);
    position: relative;
    z-index: 1;
  }
  .input-item {
    padding-left: 8px;
    font-size: 12px;
    color: #595959;
    width: 70%;
    border: 0 none;
    // flex: 1;
    &:focus {
      outline: none;
    }
    &::-webkit-input-placeholder {
      color: #cccccc;
    }
  }
}
.error-border {
  // border:  1px solid #f04134;
  // margin-left: 1px;
  // box-shadow: 0px 0px 4px 0px rgba(240, 65, 52, 0.4);
}
.range-prefix {
  margin-left: 8px;
}

.range-divided {
  font-size: 12px;
  color: #bfbfbf;
  padding: 0 6px;
}
.error-input-range {
  border: 1px solid red;
}

::v-deep{
  .el-input-number.is-controls-right{
      .el-input__inner{
        padding-left: 10px;
        text-align: left;
      }
  }
  .el-input-number--small .el-input__inner{
    width: 130px;
  }
  .el-input-number.is-controls-right[class*=small] [class*=increase], .el-input-number.is-controls-right[class*=small] [class*=decrease]{
    line-height: 17px;
  }
}

.err-empty{
  display: none;
}
.isEmpty{
  position: relative;
  transition: all 0.3s;
  /deep/ input{
    border: 1px solid #F56C6C;
  }

  .err-empty{
    display: block;
    font-size: 12px;
    color: #F56C6C;
    position: absolute;
    z-index: 11;
    bottom: -18px;
    left: 0;
  }
}
</style>
